import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import debounce     from 'debounce';
import ConfigService from '@/front/services/config';
import helper from '@/helper'
import axios from 'axios';

let singleton = Symbol();
let singletonEnforcer = Symbol();

const historicItems = 9;

class SearchService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this.ITEMS_PER_PAGE = 30;

    const historic = localStorage.getItem('history-search');
    this._updateUrl = debounce(this._updateUrl.bind(this), 200);
    this._addHistory = debounce(this._addHistory.bind(this), 200);
    this._isInit = false;
    this._historic = historic ? JSON.parse(historic) : [];
    this._filtersIsShow = false;
    this._query = '';
    this._selectedFacets = [];
    this._openedFacets = [];
    this._paramsNotices = {
      onlineFilter: 'online',
      items_per_page: this.ITEMS_PER_PAGE
    };
    this._paramsFacets = {
      onlineFilter: 'online',
      onlyEnabled: true
    };
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new SearchService(singletonEnforcer);
    }
    return this[singleton];
  }

  get query() {
    return this._query;
  }

  get historic() {
    return this._historic;
  }

  get paramsNotices() {
    return this._paramsNotices;
  }

  get paramsFacets() {
    return this._paramsFacets;
  }

  get selectedFacets() {
    return this._selectedFacets;
  }

  get openedFacets() {
    return this._openedFacets;
  }

  get onlyHasImage() {
    return this._onlyHasImage;
  }

  set page(page) {
    this._paramsNotices.page = page ? parseInt(page) : 1;
    this._updateUrl();
    if(this._isInit) {
      this.emit('update-params');
    }
  }

  set page_silence(page) {
    this._paramsNotices.page = page ? parseInt(page) : 1;
  }

  set filtersIsShow(open) {
    this._filtersIsShow = open;
    this.emit('filters-is-show', open);
  }

  set onlyHasImage(onlyHasImage) {
    this._onlyHasImage = onlyHasImage;
    this._paramsNotices.onlyHasImage = onlyHasImage;
    this._paramsFacets.onlyHasImage = onlyHasImage;
    this._updateUrl();
    if(this._isInit) {
      this.emit('update-params');
    }
  }

  set selectedFacets(facets) {
    const ids = [];
    facets = facets.filter( facet => {
      const isContain = !ids.includes(facet.id);
      if( !isContain ) ids.push(facet.id)
      return isContain;
    })
    facets.sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
    this._selectedFacets = facets;
    if(facets.length === 0) {
      delete this._paramsNotices.f;
      delete this._paramsFacets.f;
    } else {
      this._paramsNotices.f = facets.map(f => f.id);
      this._paramsFacets.f = facets.map(f => f.id);
    }
    this._updateUrl();
    if(this._isInit) this.emit('update-params');
  }

  set openedFacets(facets) {
    facets.sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
    this._openedFacets = facets;
    this._paramsFacets.o = facets.map(f => f.id);

    this._updateUrl();
  }

  set query(query) {
    query = query ? query.trim() : '';
    this._query = query;
    this._paramsNotices.query = query;
    this._paramsFacets.query = query;
    this._updateUrl();
    if(this._isInit) {
      this.emit('update-params');
    }
  }

  getDetails( facetsIds ) {
    return axios.get('/api/v2/facets', { params: { id: facetsIds }});
  }

  setIsReady() {
    this._isInit = true;
    this.emit('is-ready');
  }

  clear() {
    this.page_silence = 1;
    this.selectedFacets = [];
    this.query = null;
    this._updateUrl();
    if(this._isInit) {
      this.emit('update-params');
    }
  }

  init() {
    this.page_silence = null;
    const page = helper.getQueryParameter('p');
    if( page ) this.page_silence = parseInt(page);

    this.query = helper.getQueryParameter('query');
    this.onlyHasImage = helper.getQueryParameter('onlyHasImage');
    const facetsOpened = helper.getQueryParameter('o');
    if(facetsOpened) {
      this.openedFacets = facetsOpened.split(',').map(f => {
        return { id: parseInt(f) };
      });
    }
    this._paramsNotices = {
      ...this._paramsNotices,
      onlyHasImage: this._paramsNotices.onlyHasImage ? this._paramsNotices.onlyHasImage : ConfigService.get('onlyHasImage'),
      randomize: ConfigService.get('randomize') && !ConfigService.get('isCollectionView'),
    };
    this._paramsFacets = {
      ...this._paramsFacets,
      page: this.page_silence,
      onlyHasImage: this._paramsFacets.onlyHasImage ? this._paramsFacets.onlyHasImage : ConfigService.get('onlyHasImage'),
      randomize: ConfigService.get('randomize') && !ConfigService.get('isCollectionView'),
    }
    const collection = ConfigService.get('noticeCollectionsFilter');
    if(collection) {
      this._paramsNotices.noticeCollectionsFilter = [collection];
      this._paramsFacets.noticeCollectionsFilter = [collection];
    }
    const facetsSelected = helper.getQueryParameter('f');
    if(facetsSelected) {
      const facetsId = facetsSelected.split(',').map(f => parseInt(f) );
      this.getDetails(facetsId).then( res => {
        this.selectedFacets = res.data['hydra:member'];
        this.emit('selected')
        this.setIsReady();
      })
    } else this.setIsReady();
  }

  _addHistory(url, testUrl) {
    const params = {};
    if( this._query ) params.query = this._query;
    if( this._selectedFacets.length > 0 ) {
      params.f = this._selectedFacets;
    }
    if( !params.query && !params.f) return;
    for(let i = this._historic.length - 1; i >= 0; i--) {
      if(this._historic[i].testUrl === window.location.origin + testUrl) this._historic.splice(i, 1);
    }
    this._historic = this._historic.splice(0, historicItems - 1);
    this._historic = [
      {
        url: window.location.origin + url,
        testUrl: window.location.origin + testUrl,
        params: params,
        date: new Date()
      },
      ...this._historic
    ];
    localStorage.setItem('history-search', JSON.stringify(this._historic));
    this.emit('historic', this._historic);
  }

  _updateUrl() {
    if(!this._isInit) return;
    helper.setQueryStringParameter('o');
    helper.setQueryStringParameter('query', this._query);
    helper.setQueryStringParameter('f', this._paramsFacets.f);
    const testUrl = helper.setQueryStringParameter('onlyHasImage', this._paramsFacets.onlyHasImage ? this._paramsFacets.onlyHasImage : '');
    const url = helper.setQueryStringParameter('o', this._paramsFacets.o);
    this._addHistory( url, testUrl );
    if(this._paramsNotices.page > 1) helper.setQueryStringParameter('p', this._paramsNotices.page);
  }

}
export default SearchService.getInstance();